import { default as classNames, default as cn } from "classnames"
import { RenderBardWithComponents } from "components/Wysiwyg"
import { DynamicHeadline } from "../DynamicHeadline"
import Image from "../Image"
import Section from "../Section"
import LinkButton from "../ui/LinkButton"
import styles from "./ImageGrid.module.scss"

const ImageGrid = ({ data = {}, colors }) => {
  const {
    image_grid_dynamic_headline: dynamicHeadline,
    image_grid_headline_type: headlineType,
    image_grid_headline_appearance: headlineAppearance,
    image_grid_images: images,
    image_grid_text: text,
    image_grid_link_text: linkText,
    image_grid_link_url: linkUrl,
    image_grid_link_blank: linkBlank,
    versatz,
    ankerslug,
  } = data

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      className={styles.imageGrid}
      colors={colors}
    >
      <div className={styles.headlineWrapper}>
        <div className={styles.headlineContent}>
          <DynamicHeadline
            className={styles.headline}
            headlineType={headlineType.value}
            headlineAppearance={headlineAppearance.value}
          >
            {dynamicHeadline}
          </DynamicHeadline>
          {text && (
            <div>
              <RenderBardWithComponents
                content={text}
                prefix="image_grid_text_"
              />
            </div>
          )}
          {linkUrl && (
            <LinkButton
              data={{
                link_text: linkText,
                link_url: linkUrl,
                show_arrow: true,
              }}
            />
          )}
        </div>
      </div>
      <div className={styles.images}>
        {images &&
          images.map((image, i) => {
            return (
              <div
                className={classNames(styles.imageWrapper, {
                  [styles.imageWrapperMargin]: versatz && i % 2 === 1,
                })}
                key={i}
              >
                <div className={styles.image}>
                  <Image
                    src={image.image.permalink}
                    alt={image.image?.alt}
                    layout="fill"
                    fill="objectFit"
                    objectFit="cover"
                    sizes="(max-width: 767px) 100vw, 50vw"
                  />
                </div>
                <div className={cn(styles.caption, "caption")}>
                  {image.caption}
                </div>
              </div>
            )
          })}
      </div>
    </Section>
  )
}

export default ImageGrid
